import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "feedback-dialog"
}
const _hoisted_2 = { class: "feedback-dialog-main" }
const _hoisted_3 = { class: "feedback-dialog-header" }
const _hoisted_4 = { class: "dialog-header-container" }
const _hoisted_5 = { class: "dialog-header-title" }
const _hoisted_6 = { class: "dialog-select-container" }
const _hoisted_7 = { class: "dialog-session-title" }
const _hoisted_8 = { class: "dialog-button-list" }
const _hoisted_9 = { class: "dialog-button-row" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "dialog-other-feedback-container" }
const _hoisted_12 = { class: "dialog-session-title" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "dialog-foot" }
const _hoisted_15 = {
  key: 1,
  class: "edit-form"
}
const _hoisted_16 = { class: "edit-form-item" }
const _hoisted_17 = { class: "dialog-title" }
const _hoisted_18 = { class: "dialog-header-title" }
const _hoisted_19 = { class: "dialog-select-container-h5" }
const _hoisted_20 = { class: "dialog-session-title" }
const _hoisted_21 = { class: "dialog-button-list" }
const _hoisted_22 = { class: "dialog-button-row" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "dialog-other-feedback-container-h5" }
const _hoisted_25 = { class: "dialog-session-title" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = { class: "dialog-foot-h5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_FormPopup = _resolveComponent("FormPopup")!

  return (_openBlock(), _createElementBlock("div", null, [
    ($setup.isPC)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString($setup.TUITranslateService.t("AIDesk.感谢您的反馈，我们会持续优化改进")), 1)
              ]),
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeFeedbackModal && $setup.closeFeedbackModal(...args)))
              }, [
                _createVNode(_component_Icon, {
                  file: $setup.DialogCloseIcon,
                  width: "20px",
                  height: "20px"
                }, null, 8, ["file"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString($setup.TUITranslateService.t("AIDesk.您遇到了哪方面的问题")), 1),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.feedbackButtonList, (item) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['dialog-button',item.isSelected ? 'dialog-button-selected': '']),
                      onClick: ($event: any) => ($setup.dialogButtonClick(item))
                    }, _toDisplayString($setup.feedbackButtonListFromStore ? item.content : $setup.TUITranslateService.t(`AIDesk.${item.content}`)), 11, _hoisted_10)
                  ]))
                }), 256))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString($setup.TUITranslateService.t("AIDesk.其他反馈内容")), 1),
              _withDirectives(_createElementVNode("textarea", {
                type: "text",
                placeholder: $setup.TUITranslateService.t('AIDesk.我们想知道你对此回答不满意的原因，你认为更好的回答是什么？'),
                maxlength: "200",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.feedbackText) = $event)),
                class: "dialog-other-feedback-input"
              }, null, 8, _hoisted_13), [
                [_vModelText, $setup.feedbackText]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                class: _normalizeClass($setup.isSubmitEnabled ? 'dialog-submit' : 'dialog-submit disabled'),
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)))
              }, _toDisplayString($setup.TUITranslateService.t("AIDesk.提交")), 3),
              _createElementVNode("div", {
                class: "dialog-cancel",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.closeFeedbackModal && $setup.closeFeedbackModal(...args)))
              }, _toDisplayString($setup.TUITranslateService.t("AIDesk.取消")), 1)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_FormPopup, {
              class: "form-item",
              show: true,
              showHeaderCloseButton: false,
              onOnClose: $setup.closeFeedbackModal,
              title: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString($setup.TUITranslateService.t("AIDesk.感谢您的反馈，我们会持续优化改进")), 1),
                  _createVNode(_component_Icon, {
                    file: $setup.DialogCloseIcon,
                    width: "16px",
                    height: "16px",
                    onClick: $setup.closeFeedbackModal
                  }, null, 8, ["file", "onClick"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString($setup.TUITranslateService.t("AIDesk.您遇到了哪方面的问题")), 1),
                  _createElementVNode("div", _hoisted_21, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.feedbackButtonList, (item) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", {
                          class: _normalizeClass(['dialog-button',item.isSelected ? 'dialog-button-selected': '']),
                          onClick: ($event: any) => ($setup.dialogButtonClick(item))
                        }, _toDisplayString($setup.feedbackButtonListFromStore ? item.content : $setup.TUITranslateService.t(`AIDesk.${item.content}`)), 11, _hoisted_23)
                      ]))
                    }), 256))
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString($setup.TUITranslateService.t("AIDesk.其他反馈内容")), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    type: "text",
                    placeholder: $setup.TUITranslateService.t('AIDesk.我们想知道你对此回答不满意的原因，你认为更好的回答是什么？'),
                    maxlength: "200",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.feedbackText) = $event)),
                    class: "dialog-other-feedback-input"
                  }, null, 8, _hoisted_26), [
                    [_vModelText, $setup.feedbackText]
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", {
                    class: _normalizeClass($setup.isSubmitEnabled ? 'dialog-submit' : 'dialog-submit disabled'),
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)))
                  }, _toDisplayString($setup.TUITranslateService.t("AIDesk.提交")), 3)
                ])
              ]),
              _: 1
            }, 8, ["onOnClose"])
          ])
        ]))
  ]))
}